<template>
  <v-card class="px-10 py-5">
    <PatientDialog
      :visible="dialog"
      :item="editedItem"
      @save="save"
      @close="close"
    />
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5"
          >¿Seguro que quieres eliminar el paciente?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeDelete"
            >Cancelar</v-btn
          >
          <v-btn color="red darken-1" text @click="deleteItemConfirm"
            >Eliminar</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row>
      <v-col cols="12" md="3" sm="12">
        <v-btn @click="newItem" color="blue-grey" class="ma-2 white--text">
          Nuevo Paciente
          <v-icon right dark>
            mdi-plus
          </v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" md="4" sm="12">
        <v-select
          :items="searchableFields"
          v-model="activeFilter"
          item-text="text"
          item-value="value"
          label="Campos"
        ></v-select>
      </v-col>
      <v-col cols="12" md="4" sm="12">
        <v-text-field
          v-model="filterSearch"
          append-icon="mdi-magnify"
          label="Filtrar"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="12" sm="12">
        <v-combobox
          v-model="selectedFields"
          :items="allFields"
          label="Columnas"
          multiple
          chips
        ></v-combobox>
      </v-col>
    </v-row>
    <v-data-table
      :headers="selectedHeaders"
      :items="patients"
      :options.sync="options"
      multi-sort
      :server-items-length="totalPatients"
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:item.Acompanhado_por_padres="{ item }">
        <v-icon :color="(item.Acompanhado_por_padres && 'green') || 'red'">{{
          `mdi-${(item.Acompanhado_por_padres && "check") || "close"}`
        }}</v-icon>
      </template>
      <template v-slot:item.Asegurado="{ item }">
        <v-icon :color="(item.Asegurado && 'green') || 'red'">{{
          `mdi-${(item.Asegurado && "check") || "close"}`
        }}</v-icon>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)">
          mdi-pencil
        </v-icon>
        <v-icon small class="mr-2" @click="deleteItem(item)">
          mdi-delete
        </v-icon>
        <a
          @click="
            $router.push({
              name: 'Tratamientos',
              params: { patientId: item.id },
            })
          "
          >Tratamientos</a
        >
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import axios from "@/utils/axios.js";
import PatientDialog from "@/components/PatientDialog.vue";
export default {
  components: { PatientDialog },
  data() {
    return {
      totalPatients: 0,
      patients: [],
      filterSearch: null,
      loading: true,
      activeFilter: "Nombre",
      options: {},
      editedIndex: -1,
      dialog: false,
      dialogDelete: false,
      editedItem: {
        id: null,
        Nombre: null,
        Apellido: null,
        Telefono: null,
        Entrada: null,
        Numero: null,
        Historia: ``,
        Fecha_nacimiento: null,
        Oficio: null,
        Email: null,
        Acompanhado_por_padres: null,
        Contacto_a_la_clinica: null,
        Asegurado: null,
      },
      selectedFields: [
        "Email",
        "Nombre",
        "Apellidos",
        "Teléfono",
        "Contacto",
        "Acciones",
      ],
      headers: [
        {
          text: "Nombre",
          align: "start",
          sortable: true,
          searchable: true,
          value: "Nombre",
          display: "text",
        },
        {
          text: "Apellidos",
          sortable: true,
          searchable: true,
          value: "Apellido",
          display: "text",
        },
        {
          text: "Teléfono",
          sortable: true,
          searchable: true,
          value: "Telefono",
          display: "text",
        },
        {
          text: "Entrada",
          sortable: true,
          searchable: true,
          value: "Entrada",
          display: "text",
        },
        {
          text: "Numero",
          sortable: true,
          searchable: true,
          value: "Numero",
          display: "text",
        },
        {
          text: "F. Nacimiento",
          sortable: true,
          searchable: true,
          value: "Fecha_nacimiento",
          display: "text",
        },
        {
          text: "Contacto",
          sortable: true,
          searchable: true,
          value: "Contacto_a_la_clinica",
          display: "text",
        },
        {
          text: "Oficio",
          sortable: true,
          searchable: true,
          value: "Oficio",
          display: "text",
        },
        {
          text: "Email",
          sortable: true,
          searchable: true,
          value: "Email",
          display: "text",
        },
        {
          text: "Acomp. Padres",
          sortable: true,
          searchable: true,
          value: "Acompanhado_por_padres",
          display: "boolean",
        },
        {
          text: "Asegurado",
          sortable: true,
          searchable: true,
          value: "Asegurado",
          display: "boolean",
        },
        { text: "Acciones", value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    searchableFields() {
      return this.selectedHeaders.filter((h) => h.searchable);
    },
    allFields() {
      return this.headers.map((h) => h.text);
    },
    selectedHeaders() {
      return this.headers.filter((h) => {
        return this.selectedFields.includes(h.text);
      });
    },
  },
  watch: {
    options: {
      handler() {
        this.getDataFromApi();
      },
      deep: true,
    },
    filterSearch: {
      handler() {
        this.getDataFromApi();
      },
    },
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  methods: {
    newItem() {
      this.editedItem = Object.assign(
        {},
        {
          id: null,
          Nombre: null,
          Apellido: null,
          Telefono: null,
          Entrada: null,
          Numero: null,
          Historia: `
         
<strong>Medicamentos diarios</strong><br>
<br><br>
<strong>Alergías, Dermatología</strong>(Medicamentos, polen, alimentos)<br>
<br><br>
<strong>Suplementos alimentarios</strong>(Magnesio, calcio, proteínas, vitaminas, etc.)<br>
<br><br>
<strong>Accidentes</strong>(Automóvil, bicicleta, deporte, tiempo libre, trauma supina-torio)<br>
<br><br>
<strong>Operaciones</strong>(Apendicitis, cholezstitis, etc.)<br>
<br><br>
<strong>Neurología</strong>(Cephalia frecuentes, sensación depresión/sensación de vacío, Mareo, Epilepsia, Esclerosis múltiple, cambios de sabor/olfato, defecto visual, dolor de movimiento ocular, memoria, concentración, pérdida de sensaciones parestesias, pérdida de fuerza potencia, molestias dificultad de tragar.)<br>
<br><br>
<strong>Maxila-Mandíbula</strong>(Dientes/Estado de dental, crujido dental, aparatos dentales, CMD, OP, restricciones de movimiento.)<br>
<br><br>
<strong>Otorrinolaringología</strong>(Oídos tinitus/ oír bien mal, vértigo, dificultades de tragar, infecciones.)<br>
<br><br>
<strong>Tiroides</strong>(Hypo/Hyper Tumor caliente frío.)<br>
<br><br>
<strong>Pulmón</strong>(Dificultad respiratoria, dyspnoe apnoe... en esfuerzo o reposo, nocturno, Asthma, COPD, Enfermedades preexistentes.)<br>
<br><br>
<strong>Implantes</strong><br>
<br><br>
<strong>Vista</strong><br>
<br><br>
<strong><span style="font-size: 16px;">Cardio vascular </span></strong>(Hyper-/Hypotonia, Arritmias, marca pasos, Arteriosclerosis, A.P Infartos, tropiezo cardial, Trombosis.)<br>
<br><br>
<strong><span style="font-size: 16px;">Gastro intestinal </span></strong>(Dolores/ardor/Presión retroesternal, hinchazó-/tenso-/tensión, dolores molestias después a poco tiempo después de 2 horas de terminar de comer, defecación -/frecuencia-/ color-/olor -/adición como sangre, etc.)<br>
<br><br>
<strong>Páncreas</strong> (Restos de alimentos no digeridos en la defecación, dolores como un cinturón en la parte superior del abdomen, piel amarilla, dificultad para respirar.)<br>
<br><br>
<strong>Hígado, bazo</strong> (Inflamaciones, cirrosis, cansancia fatiga, tensión en abdomen superior)<br>
<br><br>
<strong>Riñones Vejiga Vesícula</strong> (Quistes, inflamación, malestar al orinar nocturno, color(olor de la orina.)<br>
<br><br>
<strong>Ginecóloga Urología</strong> (Frecuencia menstruación(frecuente, mucho, poco, PMS, Embarazo, actualmente embarazada, Partos, OP, Infecciones.)<br>
<br><br>
<strong>Ortopedia</strong> (Dolores articulares, resticciones de movimiento, hinchazón, Accidentes, fracturas, OP.)<br>
<br><br>
<strong>General</strong> (OP, Vacunas y reacciones, pérdida de peso corporal, sudor nocturno, Hemorragias, capacidad de potencia corporal bajada etc, Nutrición, comportamiento a bebidas, Drigas, abuso de medicamentos, Nicotina, alcohol, tiempo libre - deporte, carga laboral profesional.)<br>
<br><br>
<strong>Hidratación</strong>
<br><br>
<strong>Fiebre</strong>
<br><br>
<strong>COMPLEMENTO:</strong>
          `,
          Fecha_nacimiento: null,
          Oficio: null,
          Email: null,
          Acompanhado_por_padres: null,
          Contacto_a_la_clinica: null,
          Asegurado: null,
        }
      );
      this.dialog = true;
    },
    editItem(item) {
      this.editedIndex = this.patients.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.patients.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    deleteItemConfirm() {
      let self = this;
      axios
        .delete(`/pacientes/${this.editedItem.id}`)
        .then(() => {
          self.$alertify.success("Paciente eliminado");
        })
        .catch(() => {
          self.$alertify.error("Ha ocurrido un error");
        })
        .then(() => {
          self.closeDelete();
          self.getDataFromApi();
        });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    save(data) {
      let self = this;
      if (this.editedItem.id) {
        axios
          .put(`/pacientes/${this.editedItem.id}`, data)
          .then(() => {
            self.$alertify.success("Paciente actualizado");
          })
          .catch(() => {
            self.$alertify.error("Ha ocurrido un error");
          })
          .then(() => {
            self.close();
            self.getDataFromApi();
          });
      } else {
        delete data.id;
        axios
          .post(`/pacientes`, data)
          .then(() => {
            self.$alertify.success("Paciente creado");
          })
          .catch(() => {
            self.$alertify.error("Ha ocurrido un error");
          })
          .then(() => {
            self.close();
            self.getDataFromApi();
          });
      }
    },
    getDataFromApi() {
      this.loading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      const _sort = sortBy
        .map(function(e, i) {
          return `${e}:${(sortDesc[i] && "DESC") || "ASC"}`;
        })
        .join(",");
      const qs = require("qs");

      let params = {
        _start: (page - 1) * itemsPerPage,
        _limit: itemsPerPage,
      };

      if (sortBy.length > 0) {
        params._sort = _sort;
      }

      if (this.filterSearch) {
        params._where = {
          _or: [
            { FIELD: this.filterSearch },
            { FIELD_contains: this.filterSearch },
          ],
        };
      }

      const query = qs
        .stringify(params, {
          encodeValuesOnly: true,
        })
        .replace(/FIELD/g, this.activeFilter);

      axios.get(`/pacientes?${query}`).then((res) => {
        this.patients = res.data;
        axios.get(`/pacientes/count?${query}`).then((resCount) => {
          this.totalPatients = resCount.data;
          this.loading = false;
        });
      });
    },
  },
};
</script>
<style lang="scss"></style>
